// @flow
import './default-bundle';

import BandCatalog from '@components/pages/bands/BandCatalog';
import BandProductDetail from '@components/pages/bands/ProductDetail';

ReactOnRails.register({
  BandProductDetail,
  BandCatalog
});
